import {
  selectGoblinsTrapDeathHexKeys,
  selectHexes,
  selectUnits
} from "../../../redux/reducers/sharedStateReducer/selectors";
import {calculateAvailableManeuverCells} from "../calculateAvailableManeuverCells";
import {checkIfUnitCouldManeuverFromHex} from "../maneuver/checkIfUnitCouldManeuverFromHex";
import {checkIfUnitManeuverProcessed} from "./checkIfUnitProcessed";
import {getGridGeometry} from "./getGridGeometry";

/**
 * Может ли отряд игрока совершить манёвр: еще не маневрировал, есть право на
 * манёвр (дополнительное снабжение и участие в этапе войны стрельбой, боем или
 * способностью, см. checkIfUnitCouldManeuverFromHex) и есть свободная смежная
 * ячейка. Сначала дешевые отсечки, поиск ячеек — последним.
 */
export const checkIfUnitCanManeuver = (state, unit, player) => {
  const hexes = selectHexes(state);
  if (unit.ownerId !== player.id
    || checkIfUnitManeuverProcessed(state, unit)
    || !checkIfUnitCouldManeuverFromHex(player, unit, hexes)
  ) {
    return false;
  }

  return calculateAvailableManeuverCells(
    getGridGeometry(state), hexes, selectUnits(state), unit, selectGoblinsTrapDeathHexKeys(state)
  ).length > 0;
};
